// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_NO_MORE_PRODUCTS = "Je n\u00e1m l\u00edto, ale \u017e\u00e1dn\u00fd inzer\u00e1t nespl\u0148uje tvoje zad\u00e1n\u00ed.";
